import axiosRequest from "@/utils/axios-config";

export const getContactUsFields = async (handshake, locale) => {
  const config = {
    method: "get",
    url: `/contact/fields-data-${locale}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const submitContactUsForm = async (handshake, values) => {
  const data = JSON.stringify({
    ...values,
  });
  const config = {
    method: "post",
    url: "/contact/sumbit-form",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};
